import moment from "moment";
import { Link } from "react-router-dom";
import Terms from "../modals/terms";
import { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useTranslations } from "../../translations";

const Footer = ({ logged = null, isTerms = false }) => {
  const [modalShow, setModalShow] = useState(false);
  const year = moment().year();
  const { t } = useTranslations();
  if (logged) {
    return (
      <footer className="mt-auto py-5 border-top border-light">
        <div className="container-fluid d-flex flex-column flex-md-row justify-content-between align-items-center opacity-75">
          <div className="copyright small mb-2 mb-md-0">
             © {year} <span className="fw-bold color-plum">MIABCONLINE</span> de <strong className="ms-1">Diazapps</strong>.
          </div>
          <div className="footer-links d-flex gap-4">
            <Link to="/actions/downloads" className="text-decoration-none small text-muted hover-pink transition-all">{t("downloads")}</Link>
            <Link to="/privacy" className="text-decoration-none small text-muted hover-pink transition-all">{t("privacyPolicy")}</Link>
          </div>
        </div>
        <style>{`
          .hover-pink:hover { color: var(--pink-bright) !important; }
          .color-plum { color: var(--plum-bg); }
        `}</style>
      </footer>
    );
  } else {
    return (
      <footer className="auth-footer">
        <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <div className="copyright">
            © {year} <span className="highlight">MIABCONLINE</span> {t("from")} <strong>Diazapps</strong>.
          </div>
          <div className="footer-links d-flex gap-3">
            <Link to="/privacy" className="footer-link">{t("privacyPolicy")}</Link>
            <Link to="/" className="footer-link">{t("home") || "Home"}</Link>
          </div>
        </Container>
        <style>{`
          .auth-footer {
            padding: 3rem 0;
            background: #fff;
            border-top: 1px solid #eee;
            margin-top: 4rem;
          }
          .copyright {
            color: var(--text-gray);
            font-size: 0.9rem;
          }
          .highlight {
            color: var(--plum-bg);
            font-weight: 700;
          }
          .footer-link {
            color: var(--text-gray);
            text-decoration: none;
            font-size: 0.9rem;
            font-weight: 500;
            transition: color 0.3s ease;
          }
          .footer-link:hover {
            color: var(--pink-bright) !important;
          }
        `}</style>
      </footer>
    );
  }
};

export default Footer;
